<template lang="pug">
    div.Customer-Amap(v-loading="mapLoading" v-if="id")
        div(
            :style="`height:${height}px`"
            :id="`AMap-container${id}`"
            class="map"
            tabindex="0"
            :ref="`AMapContainer${id}`"
        )
        i(
            @click="$emit('closeMapDialog')"
            class="el-icon-close Amap-close"
            v-if="showClose"
        )
        //- 搜索服务
        div.search-service(v-if="showSearch")
            el-autocomplete(
                oncopy="false"
                :trigger-on-focus="false"
                v-model="searchKey"
                class="AMap-search-autocomplete"
                :fetch-suggestions="querySearchAsync"
                placeholder="请输入关键词搜索"
                @select="handleSelect"
                size="medium"
            )
                i(
                    slot="prefix"
                    class="el-input__icon el-icon-search"
                )
</template>
<script>
export default {
    name: 'Amap',
    props: {
        id: {
            type: Number,
            default: 0,
        },
        // 显示关闭按钮
        showClose: {
            type: Boolean,
            default: true,
        },
        // 显示搜索框
        showSearch: {
            type: Boolean,
            default: true,
        },
        height: {
            type: Number,
            default: 827,
        },
        endLocation: {
            type: Object,
            default: null,
        },
        shopSetFirst: {
            type: Boolean,
            default: false,
        },
        // 当前店铺经纬度
        orgLongitude: {
            type: Number,
            default: null,
        },
        orgLatitude: {
            type: Number,
            default: null,
        },
        // 添加默认定位点
        defaultMarker: {
            type: Object,
            default() {
                return {};
            },
        },
    },
    data() {
        return {
            mapLoading: false,
            Map: null,
            Marker: null,
            placeSearch: null,
            autocomplete: null,
            searchKey: '',
            lastList: [],
            markerList: [],
        };
    },
    methods: {
        async initMap() {
            const { AMap } = window;
            // 初始化地图 (无位置，默认公司位置为地图中心)
            const LngLat = !this.defaultMarker.longitude ? new AMap.LngLat(104.066001, 30.554300) : null;
            const Map = new AMap.Map(this.$refs[`AMapContainer${this.id}`], {
                zoom: 16,
                center: LngLat,
                resizeEnable: true,
            });
            this.Map = Map;

            // 地图初始化完成事件
            Map.on('complete', () => {
                this.$emit('complete');
            });

            // 添加地图搜索服务
            let placeSearch;
            let autocomplete;
            AMap.service('AMap.PlaceSearch', () => {
                placeSearch = new AMap.PlaceSearch();
            });
            AMap.service('AMap.Autocomplete', () => {
                autocomplete = new AMap.Autocomplete();
            });
            this.autocomplete = autocomplete;
            this.placeSearch = placeSearch;
            // 回显定位点
            if (this.defaultMarker.longitude && this.defaultMarker.latitude) {
                Map.setCenter([
                    this.defaultMarker.longitude,
                    this.defaultMarker.latitude,
                ]);
                const position = new AMap.LngLat(this.defaultMarker.longitude, this.defaultMarker.latitude);
                const marker = new AMap.Marker({
                    title: `当前位置：北纬${this.defaultMarker.latitude} 东经${this.defaultMarker.longitude}`,
                    map: Map,
                    position,
                    offset: new AMap.Pixel(-13, -12),
                    // eslint-disable-next-line global-require
                    icon: require('../../../../assets/imgs/location.png'),
                    content: null,
                    draggable: false,
                    raiseOnDrag: true,
                    zIndex: 999,
                    animation: 'AMAP_ANIMATION_NONE',
                });
                Map.add(marker);
            }
        },
        // 模糊搜索地址
        querySearchAsync(value, cb) {
            if (value.indexOf('\'') > -1) {
                cb(this.lastList);
                return;
            }
            const context = this;
            const {
                placeSearch,
            } = this;

            const sugesstion = new Promise((resolve) => {
                placeSearch.search(value, (status, result) => {
                    if (result.poiList) {
                        const res = result.poiList.pois.filter(val => val.id);
                        const arr = res.map(
                            val => ({
                                name: val.name,
                                value: `${val.name} ${val.address}`,
                                location: val.location,
                                address: val.address,
                                // POI id
                                id: val.id,
                            }),
                        );
                        context.lastList = arr;
                    } else {
                        context.lastList = [];
                    }
                    resolve(context.lastList);
                });
            });
            sugesstion.then((val) => {
                cb(val);
            });
        },
        // 选中的地址搜索
        handleSelect(val) {
            const context = this;
            const map = this.Map;
            const { AMap } = window;
            const setMarker = (poiRes) => {
                // 绘制marker
                const title = `当前位置：北纬${poiRes.location.lat} 东经${poiRes.location.lng}`;
                const marker = new AMap.Marker({
                    position: poiRes.location,
                    title,
                    // eslint-disable-next-line global-require
                    icon: require('../../../../assets/imgs/location.png'),
                    zIndex: 9999,
                    offset: new AMap.Pixel(-12.5, -32),
                });
                // 搜索完成回传经纬度
                context.$emit('getShopAddress', {
                    lng: poiRes.location.lng,
                    lat: poiRes.location.lat,
                    POIId: poiRes.id,
                    adcode: poiRes.adcode,
                    address: `${poiRes.address}${poiRes.name}`,
                    regionName: `${poiRes.pname}${poiRes.cityname}${poiRes.adname}`,
                });
                context.markerList.push(marker);
                map.add(context.markerList);
            };
            AMap.service([
                'AMap.PlaceSearch',
            ], () => {
                const placeSearch = new AMap.PlaceSearch({
                    pageSize: 1,
                    pageIndex: 1,
                    // 是否强制限制在设置的城市内搜索
                    citylimit: false,
                    // eslint-disable-next-line
                        map: map,
                    autoFitView: true,
                    extensions: 'base',
                });
                    // 关键字查询
                placeSearch.search(val.value, (status, result) => {
                    let poiRes = null;
                    if (JSON.stringify(result) === '{}') {
                        // 反解析地址
                        AMap.plugin('AMap.Geocoder', () => {
                            const geocoder = new AMap.Geocoder({ extensions: 'all' });
                            geocoder.getAddress([val.location.lng, val.location.lat], (sta, res) => {
                                if (sta === 'complete' && res.info === 'OK') {
                                    poiRes = {
                                        location: { ...res.regeocode.aois[0].location },
                                        id: res.regeocode.aois[0].id,
                                        adcode: res.regeocode.addressComponent.adcode,
                                        address: '',
                                        name: res.regeocode.aois[0].name,
                                        pname: res.regeocode.addressComponent.province,
                                        cityname: res.regeocode.addressComponent.city,
                                        adname: res.regeocode.addressComponent.district,
                                    };
                                    context.clearMap();
                                    map.setCenter([res.regeocode.aois[0].location.lng, res.regeocode.aois[0].location.lat]);
                                    setMarker(poiRes);
                                }
                            });
                        });
                    } else {
                        const { poiList: { pois } } = result;
                        // eslint-disable-next-line
                        poiRes = pois[0];
                        context.clearMap();
                        setMarker(poiRes);
                    }
                });
            });
        },
        clearMap() {
            this.Map.clearMap();
            this.markerList = [];
        },
    },
    mounted() {
        this.initMap();
    },
};
</script>
<style lang="scss" type="text/scss">
    .Customer-Amap {
        .amap-copyright {
            display: none !important;
        }
        .amap-logo {
            display: none !important;
        }
        #AMap-container {
            outline: none;
        }
        .Amap-close {
            @include font_color(text_color_white);
            @include font_size(text_main_content);
            position: absolute;
            right: 13px;
            top: 20px;
            z-index: 20;
            cursor: pointer;
            &:hover {
                @include font_color(color_base_blue3);
            }
        }
        .search-service {
            position: absolute;
            left: 110px;
            top: 130px;
            border-radius: 4px;
            overflow: hidden;
        }
        .AMap-search-autocomplete {
            .el-input .el-input__inner {
                @include border_color(color_base_white);
            }
            width: 360px;
            border-radius: 20px;
            background-color: transparent;
            input {
                border-radius: 20px;
            }
        }
    }
</style>
